import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { addBadge, badgeListing, blockUnblockBadge, deleteBadge, editBadge, viewBadge } from "../apis/apiHandler";

export const allBadges = createAsyncThunk(
    'badge/list',
    async (payload, { rejectWithValue }) => {
        try {
            const response = await badgeListing(payload);
            if (response?.code === 200) {
                return response;
            }
            else {
                return rejectWithValue(response);
            }
        } catch (error) {
            return rejectWithValue(error.response.data);
        }
    }
)

export const addBadges = createAsyncThunk(
    'badge/add',
    async (payload, { rejectWithValue }) => {
        try {
            const response = await addBadge(payload);
            if (response?.code === 200) {
                return response;
            }
            else {
                return rejectWithValue(response);
            }
        } catch (error) {
            return rejectWithValue(error.response.data);
        }
    }
)

export const editBadges = createAsyncThunk(
    'badge/edit',
    async (payload, { rejectWithValue }) => {
        try {
            const response = await editBadge(payload);
            if (response?.code === 200) {
                return response;
            }
            else {
                return rejectWithValue(response);
            }
        } catch (error) {
            return rejectWithValue(error.response.data);
        }
    }
)

export const viewBadgeDetails = createAsyncThunk(
    'badge/view',
    async (payload, { rejectWithValue }) => {
        try {
            const response = await viewBadge(payload);
            if (response?.code === 200) {
                return response;
            }
            else {
                return rejectWithValue(response);
            }
        } catch (error) {
            return rejectWithValue(error.response.data);
        }
    }
)

export const deleteBadges = createAsyncThunk(
    'badge/delete',
    async (payload, { rejectWithValue }) => {
        try {
            const response = await deleteBadge(payload);
            if (response?.code === 200) {
                return response;
            }
            else {
                return rejectWithValue(response);
            }
        } catch (error) {
            return rejectWithValue(error.response.data);
        }
    }
)

export const changeBadgeStatus = createAsyncThunk(
    'badge/status',
    async (payload, { rejectWithValue }) => {
        try {
            const response = await blockUnblockBadge(payload);
            if (response?.code === 200) {
                return response;
            }
            else {
                return rejectWithValue(response);
            }
        } catch (error) {
            return rejectWithValue(error.response.data);
        }
    }
)

const initialState = {
    loading: false,
    badgeList: [],
    error: null,
    addSuccess: false,
    editSuccess: false,
    badgeDetail: {},
    deleteSuccess: false,
    statusSuccess: false
};

const BadgeSlice = createSlice({
    name: 'badge',
    initialState,
    reducers: {},

    extraReducers: (builder) => {
        builder
            .addCase(allBadges.pending, (state) => {
                state.loading = true;
            })
            .addCase(allBadges.fulfilled, (state, { payload }) => {
                state.loading = false;
                state.badgeList = payload?.data;
            })
            .addCase(allBadges.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message;
            })
            .addCase(addBadges.pending, (state) => {
                state.loading = true;
                state.addSuccess = false;
                state.error = null;
            })
            .addCase(addBadges.fulfilled, (state) => {
                state.loading = false;
                state.addSuccess = true;
            })
            .addCase(addBadges.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
                state.addSuccess = false;
            })
            .addCase(editBadges.pending, (state) => {
                state.loading = true;
                state.editSuccess = false;
                state.error = null;
            })
            .addCase(editBadges.fulfilled, (state) => {
                state.loading = false;
                state.editSuccess = true;
            })
            .addCase(editBadges.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
                state.editSuccess = false;
            })
            .addCase(viewBadgeDetails.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(viewBadgeDetails.fulfilled, (state, { payload }) => {
                state.loading = false;
                state.badgeDetail = payload?.data;
            })
            .addCase(viewBadgeDetails.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })
            .addCase(deleteBadges.pending, (state) => {
                state.loading = true;
                state.deleteSuccess = false;
                state.error = null;
            })
            .addCase(deleteBadges.fulfilled, (state) => {
                state.loading = false;
                state.deleteSuccess = true;
            })
            .addCase(deleteBadges.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
                state.deleteSuccess = false;
            })
            .addCase(changeBadgeStatus.pending, (state) => {
                state.loading = true;
                state.statusSuccess = false;
                state.error = null;
            })
            .addCase(changeBadgeStatus.fulfilled, (state) => {
                state.loading = false;
                state.statusSuccess = true;
            })
            .addCase(changeBadgeStatus.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
                state.statusSuccess = false;
            })
    }
})

export default BadgeSlice.reducer;